export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[88vh] items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=artistic%20glazed%20turquoise%20and%20warm%20amber%20ink%20wash%20painting%20background%2C%20flowing%20abstract%20mountains%20and%20mist%20with%20fine%20gold%20particles%2C%20elegant%20eastern%20aesthetic%2C%20cinematic%20ambient%20lighting&width=1800&height=1000&seq=hero-bg-2026&orientation=landscape"
          alt="琉璃神社画廊背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/65"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-5xl px-4 py-24 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-4 py-1.5 text-xs md:text-sm font-medium tracking-widest text-white backdrop-blur">
          <i className="ri-sparkling-2-fill text-accent-300"></i>
          画廊图集 · 原画插画 · 视觉画风
        </span>

        <h1 className="mt-6 font-heading text-3xl font-bold leading-tight text-white sm:text-4xl md:text-6xl">
          汇聚海量 ACG 画廊图集
          <span className="mt-2 block bg-gradient-to-r from-accent-300 via-background-100 to-accent-300 bg-clip-text text-transparent">
            一站鉴赏原画与插画之美
          </span>
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-sm leading-relaxed text-white/85 md:text-lg">
          从原画设定到精美插画，从古典画风到治愈壁纸。琉璃神社带你细品每一处笔触与光影，
          感受多元画风背后的视觉美学，畅享一场纯粹的视觉盛宴。
        </p>

        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4">
          <a
            href="#gallery"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 shadow-lg shadow-primary-500/30 transition hover:bg-primary-600 sm:w-auto cursor-pointer"
          >
            浏览精选图集
            <i className="ri-arrow-down-line ml-2"></i>
          </a>
          <a
            href="#styles"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-full border border-white/30 bg-white/10 px-7 py-3 text-sm font-medium text-white backdrop-blur transition hover:bg-white/20 sm:w-auto cursor-pointer"
          >
            探索多元画风
          </a>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-4 sm:grid-cols-4">
          {[
            { num: "1200+", label: "精选图集" },
            { num: "860+", label: "高清壁纸" },
            { num: "36", label: "多元画风" },
            { num: "24w+", label: "艺术同好" },
          ].map((s) => (
            <div key={s.label} className="rounded-xl border border-white/15 bg-white/5 px-3 py-4 backdrop-blur">
              <p className="font-heading text-xl font-bold text-accent-300 md:text-2xl">{s.num}</p>
              <p className="mt-1 text-xs text-white/75 md:text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      <a
        href="#gallery"
        className="absolute bottom-6 left-1/2 z-10 flex h-10 w-10 -translate-x-1/2 items-center justify-center rounded-full border border-white/30 text-white/80 transition hover:text-white cursor-pointer"
        aria-label="向下滚动"
      >
        <i className="ri-arrow-down-line"></i>
      </a>
    </section>
  );
}